const dayjs = require('dayjs')

const dateSort = (a,b) => {
  if(a === '') a = '01/01/1971'
  if(b === '') b = '01/01/1971'
  return dayjs(b).isAfter(dayjs(a)) ? -1 : 1
}

module.exports = dateSort